import { searchParcelStyles } from '../../api/parcel-styles.api';
import { SearchParcelStylesApiRequest } from '../../../../types/requests/parcel-styles/search-parcel-styles.request';
import { useAxiosInfiniteQuery } from './use-axios.hook';

const baseQueryKey = 'parcel-style';
const searchQueryKey = 'search';

export const useSearchParcelStyles = (params: SearchParcelStylesApiRequest) => {
  const { data, ...result } = useAxiosInfiniteQuery({
    queryKey: [baseQueryKey, searchQueryKey, params],
    queryFn: async ({ pageParam }) => (await searchParcelStyles({ cursor: pageParam, ...params })).data,
    initialPageParam: params.cursor,
    getNextPageParam: (lastResponse) => lastResponse.nextCursor,
  });
  return { ...result, response: data } as const;
};
